
export let delItem = (data, payload) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].integralCode === payload.integralCode) {
      data.splice(i, 1)
      break
    }
    if (data[i].child && data[i].child.length) {
      delItem(data[i].child, payload)
    }
  }
}

export let addItem = (data, payload) => {
  let addObj
  console.log("data",data);
  console.log("payload",payload);
  for (let i = 0; i < data.length; i++) {
    if (data[i].integralCode === payload.integralCode) {
      addObj = {
        integralCode: Math.ceil(Math.random()*100000)+"",
        integralName: payload.integralName,
        integralNum: payload.integralNum,
        levelname: payload.levelname,
        integralLevel: data[i].integralLevel + 1,
        child: []
      }
      data[i].child.unshift(addObj)
      break
    }

    if (data[i].child && data[i].child.length) {
      addItem(data[i].child, payload)
    }
  }
}

export let updateItem = (data, payload) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].integralCode === payload.integralCode) {
      data[i].integralName = payload.integralName
      data[i].integralNum = payload.integralNum
      data[i].levelname = payload.levelname
      break
    }

    if (data[i].child && data[i].child.length) {
      updateItem(data[i].child, payload)
    }
  }
}
